var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 223.6 223.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1374aa;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M223.6,111.79A111.8,111.8,0,1,1,111.52,0,111.9,111.9,0,0,1,223.6,111.79ZM92.71,99c7.26-.57,8.49.85,6.71,7.79-1.33,5.15-2.73,10.29-4,15.45-3.29,13.07-7.08,26-9.68,39.25s6.29,22.39,19.72,21.64c11.77-.65,26.17-11.65,30.15-23.33.46-1.36-.58-3.23-.92-4.86-1.6.37-3.44.35-4.73,1.19-1.76,1.16-2.93,3.19-4.65,4.45-3.19,2.34-7.34,4.42-10.42,1.46-1.67-1.61-1.52-6.15-.81-9,4.77-19.39,9.94-38.68,14.94-58,1.44-5.6.13-7.08-5.49-6.46-4.63.52-9.27,1-13.9,1.52-5.95.67-11.91,1.3-17.85,2.1-2.51.33-6,.09-5.72,4s3.6,3,6.18,2.9Zm28.75-25a16.64,16.64,0,1,0-16.48-17A16.59,16.59,0,0,0,121.46,73.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M92.71,99l-.5,0c-2.58.11-5.9,1.11-6.18-2.9s3.21-3.64,5.72-4c5.94-.8,11.9-1.43,17.85-2.1,4.63-.52,9.27-1,13.9-1.52,5.62-.62,6.93.86,5.49,6.46-5,19.33-10.17,38.62-14.94,58-.71,2.87-.86,7.41.81,9,3.08,3,7.23.88,10.42-1.46,1.72-1.26,2.89-3.29,4.65-4.45,1.29-.84,3.13-.82,4.73-1.19.34,1.63,1.38,3.5.92,4.86-4,11.68-18.38,22.68-30.15,23.33-13.43.75-22.31-8.46-19.72-21.64s6.39-26.18,9.68-39.25c1.3-5.16,2.7-10.3,4-15.45C101.2,99.84,100,98.42,92.71,99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M121.46,73.94a16.64,16.64,0,0,1,.25-33.27,16.64,16.64,0,0,1-.25,33.27Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/Info.67bcdca40e51544af17b57b3d5b16ace.svg";
export { ForwardRef as ReactComponent };